import {
  DeleteRequest,
  GetRequest,
  PostRequest,
  PutRequest,
} from "../../plugins/https";
import { getAlumni, setAlumni, deleteAlumni, updateAlumni } from "./action";
import {
  SET_ALUMNI,
  GET_ALUMNI,
  DELETE_ALUMNI,
  UPDATE_ALUMNI,
} from "./actionType";

export const addAlumni = (alumni) => async (dispatch) => {
  try {
    const res = await PostRequest("/alumni", alumni);
    dispatch(setAlumni(res.data));
    dispatch(getAlumniData());
  } catch (error) {
    console.error(error);
  }
};

export const getAlumniData = () => async (dispatch) => {
  try {
    const res = await GetRequest("/alumni");
    dispatch(getAlumni(res.data));
  } catch (error) {
    console.error("Error getting alumni:", error);
  }
};

export const updateAlumniData = (id, updateAlumniData) => async (dispatch) => {
  try {
    const res = await PutRequest(`/alumni/${id}`, updateAlumniData); // Send the updated data
    dispatch(updateAlumni(res.data)); // Assuming the updated data is returned
    dispatch(getAlumniData());
  } catch (error) {
    console.error("Error in updating alumni: ", error);
  }
};

export const deleteAlumniData = (id) => async (dispatch) => {
  try {
    const res = await DeleteRequest(`/alumni/${id}`);
    dispatch(deleteAlumni(id));
    dispatch(getAlumniData());
  } catch (error) {
    console.error("Error in deleting alumni: ", error);
  }
};

const initialState = {
  alumni: "",
  alumniData: [],
};

export const alumniReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALUMNI:
      return {
        ...state, // Copy the previous state
        alumni: action.payload, // Update the 'contact' field with the new contact
      };
    case GET_ALUMNI:
      return {
        ...state, // Copy the previous state
        alumniData: action.payload, // Update the 'contact' field with the new contact
      };
    case UPDATE_ALUMNI:
      return {
        ...state,
        alumniData: state.alumniData.map((item) =>
          item.id === action.payload.id ? { ...item, ...action.payload } : item
        ), // Update the specific item
      };
    case DELETE_ALUMNI:
      return {
        ...state,
        contactData: state.alumniData.filter(
          (item) => item.id !== action.payload
        ),
      };
    default:
      return state;
  }
};
